import { useFeatureAccess } from './useFeatureAccess';
import { useGptLiveEnabled } from './useGptLiveEnabled';
import { canShowVoiceMessageNotifications } from '../business/voice-agent/voiceMessageNotifications';

/**
 * Whether to show the "Phone Message" notification settings (company toggle and
 * per-user preference row): the plan includes voice agents AND the tenant has
 * GPT-Live (an active GPT-Live line; Vapi-native lines can't take messages).
 * Does not gate displaying the notifications.
 *
 * @param active Pass the panel's `isOpen` so the GPT-Live check only runs while
 *   the panel is open. It is also skipped when the plan has no voice agents.
 */
export function useVoiceMessageNotificationsVisible(active: boolean = true): boolean {
  const { available, loading } = useFeatureAccess('VoiceAgent');
  const voiceAgentPlan = available && !loading;
  const gptLiveEnabled = useGptLiveEnabled(active && voiceAgentPlan);
  return canShowVoiceMessageNotifications({
    voiceAgentAvailable: available,
    voiceAgentLoading: loading,
    gptLiveEnabled,
  });
}
